import "../../../../src/content/cochabamba-streaming/cochabamba-streaming.scss";
import * as React from 'react';
export default {
  React
};